import React from 'react';
import { Container } from 'react-bootstrap';
import '../styles/About.css';

export default function About() {
    return (
        <section id='about' className='about'>
            <Container>
                <h2 className='text-center about-heading pb-3'>Hello, I'm <span className="name">Labib</span>. Nice to see you here </h2>
                <p className='about-text'>I'm a curious web and app developer from <b>Bangladesh</b>. I started my development journey in March 2021. After taking a long training, I'm here for you. I'm a MERN stack developer and Flutter developer as well. I love to make your dream website with natural curiosity, creative design, and clean code. I'm eager to learn more and take my skills leveled up to give you my best.</p>
            </Container>
        </section>
    );
};